import { useMedia } from 'hooks/useMedia'
import { breakpoints } from 'styles/mq'
import SwiperGraphs from './swiper-graphs'
import ScrollGraphs from './scroll-graphs'

export const Graphs = () => {
  const isMobile = useMedia([breakpoints.smallOnly], [true], false)
  return <>{isMobile ? <SwiperGraphs /> : <ScrollGraphs />}</>
}
